export const HOME_CARD_LIMIT = 6

export const MOBILE_CARD_LIMIT = 3

export const ISSUE_ICONS = [
  '/icon/problem/card-01.svg',
  '/icon/problem/card-02.svg',
  '/icon/problem/card-03.svg',
] as const

export const ICON_BY_CODE: Record<string, string> = {
  catg_care_relation: '/category-icons/family-care.svg',
  catg_mobility_safety: '/category-icons/traffic-safety.svg',
  catg_learn_work_digital: '/category-icons/learning-work.svg',
  catg_env_culture: '/category-icons/environment-culture.svg',
  catg_rights_admin: '/category-icons/rights-admin.svg',
  catg_health_housing_food: '/category-icons/health-housing.svg',
}
